module.exports = __webpack_public_path__ + "assets/img/066301.7ca93da9.png";